import { requestApi } from '@app/api';
import { withIdentityAccess } from '@app/api/paths';

interface GetUserProviderResponse {
  result: {
    provider: string;
  };
}

/**
 * GET 유저 제공자 조회
 * @param {string} email - 이메일
 * @return {string} - 제공자
 */
// eslint-disable-next-line import/prefer-default-export
export function getUserProvider(email: string): Promise<string> {
  return requestApi<GetUserProviderResponse>({
    url: withIdentityAccess('/user/provider'),
    method: 'GET',
    params: { email },
    credentials: false,
  }).then((response) => response.data.result.provider);
}
